import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class ProcessService extends Service {
	constructor(injector: Injector) {
		super("Process", injector);
	}
}